module.exports = __webpack_public_path__ + "img/1 (8).f5ec19c1.jpg";